import { CLICK, componentWithVariants, demoFile, INPUT, story, variant } from "system/demo";
import { QuestionListScreen } from 'feature/admin/question-list';

demoFile('feature/admin/question-list');

const oldTime = new Date('2024-1-1').valueOf();
const recentTime = new Date("2026-1-1").valueOf();


componentWithVariants('QuestonListScreen', QuestionListScreen, {}, [
    variant(null, {
        state: {
            roles: ['Owner'],
            modulePublic: {
                question: {
                    a: {question: 'What is the capital of France?', key: 'a', time: recentTime},
                    b: {question: 'What is the capital of Germany?', key: 'b', time: recentTime},
                    c: {question: 'What is the capital of Italy?', key: 'c', time: recentTime},
                    d: {question: 'This is an old question you cannot see?', key: 'd', time: oldTime},
                }
            }
        }
    }, [
        story('Add a question', [
            INPUT('add-question', 'What is the capital of Spain?'),
            CLICK('Add Question')
        ]),
        story('Search for a question', [
            INPUT('add-question', 'Germany'),
        ]),
        story('Select a question', [ 
            CLICK('What is the capital of Germany?')
        ])
    ])
])


